import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SkillListComponent } from '../skill-list/skill-list.component';
import { SkillFormDialogComponent } from '../skill-form-dialog/skill-form-dialog.component';

@Component({
  selector: 'app-skill-main',
  standalone: true,
  imports: [CommonModule, SkillListComponent, SkillFormDialogComponent],
  templateUrl: './skill-main.component.html',
})
export class SkillMainComponent {
  reloadVersion = 0;
  showFormDialog = false;

  onAddNew(): void {
    this.showFormDialog = true;
  }

  onDialogHide(): void {
    this.showFormDialog = false;
  }

  onSaved(): void {
    this.showFormDialog = false;
    this.reloadVersion++;
  }

  onDeleted(): void {
    this.reloadVersion++;
  }
}
